import { Pipe, PipeTransform } from '@angular/core';
import { SelectableItem } from '../models/selectable-item';
export class ItemPipe implements PipeTransform {
/**
 * @param {?} value
 * @return {?}
 */
public transform(value: SelectableItem[]) {
    // ES6 array destructuring
    return value.filter((item) => item.matchFilter);
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{ name: 'itemPipe' }, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ItemPipe_tsickle_Closure_declarations() {
/** @type {?} */
ItemPipe.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ItemPipe.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
